import Tooltip, { TooltipProps } from 'antd/es/tooltip';
import cx from 'clsx';
import React, { forwardRef, ForwardRefRenderFunction } from 'react';

import s from './AntTooltip.module.less';

const AntTooltipComponent: ForwardRefRenderFunction<any, TooltipProps> = (props, ref) => {
  const { overlayClassName, ...rest } = props;

  return <Tooltip ref={ref} className={cx(s.wrapper, overlayClassName)} {...rest} />;
};

export const AntTooltip = forwardRef(AntTooltipComponent);
